(function (){
    'use strict';

    angular
        .module('payees', []);
})();